import React, { useRef, useState } from 'react'
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { toggleSnackbar } from '../../redux/actions/authActions';
import SearchIcon from '@mui/icons-material/Search';
import SearchResearch from './SearchResearch.jsx';
import TicketResearch from './TicketResearch.jsx';

const Research = ({ subDomain, ticketingSystem, prismToken, ticketId, orgId, agentDetails, userEmail }) => {
  const ticketDetails = useSelector((state) => state.ticket.ticketDetails);
  const [tab, setTab] = useState("Search Research");
  const currentSearchQuery = useSelector((state) => state.search.searchQuery);
  const [searchQuery, setSearchQuery] = useState(currentSearchQuery);
  const [validSearch, setValidSearch] = useState(false);
  const searchInputRef = useRef(null);
  const dispatch = useDispatch();

  const handleSearch = (event) => {
    event.preventDefault();
    if (!event.target.checkValidity()) {
      event.stopPropagation();
      return;
    }
    if (searchQuery.trim().length <= 3) {
      dispatch(toggleSnackbar({ message: "The Search Query Should Be More Than 3 Characters Long.", status: true, severity: "warning" }))
      return
    }
    else {
      setTab("Search Research");
      setValidSearch(true);
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between" }}>
      {
        ticketId ?
          <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", gap: "15px" }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "10%" }}>
              <ToggleButtonGroup fullWidth color="primary" value={tab} exclusive onChange={(event) => setTab(event.target.value)} >
                <ToggleButton value="Search Research" sx={{ fontWeight: "bold" }} >Search Research</ToggleButton>
                <ToggleButton value="Ticket Research" sx={{ fontWeight: "bold" }} >Ticket Research</ToggleButton>
              </ToggleButtonGroup>
            </Box>
            <div style={{ border: "1px solid black", borderRadius: "0.5rem", padding: "1rem", height: "60vh" }}>
              {tab === "Search Research" && <SearchResearch searchQuery={searchQuery} subDomain={subDomain} ticketingSystem={ticketingSystem} prismToken={prismToken} ticketId={ticketId} orgId={orgId} agentDetails={agentDetails} userEmail={userEmail} ticketDetails={ticketDetails} validSearch={validSearch} searchInputRef={searchInputRef} setTab={setTab} />}
              {tab === "Ticket Research" && <TicketResearch subDomain={subDomain} ticketingSystem={ticketingSystem} prismToken={prismToken} ticketId={ticketId} orgId={orgId} agentDetails={agentDetails} userEmail={userEmail} ticketDetails={ticketDetails} />}
            </div>
            <form onSubmit={handleSearch} style={{ width: "100%", height: "100%" }}>
              <FormControl required fullWidth variant="outlined" sx={{ textTransform: "none" }}>
                <InputLabel>Search Knowledge Base</InputLabel>
                <OutlinedInput
                  type="text"
                  value={searchQuery}
                  fullWidth
                  inputRef={searchInputRef}
                  sx={{ textTransform: "none" }}
                  onChange={(event) => {
                    setSearchQuery(event.target.value)
                    setValidSearch(false)
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton type="submit" edge="end" >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Search Knowledge Base"
                />
              </FormControl>
            </form>
          </div>
          :
          <div></div>
      }
    </div>
  )
}

export default Research